import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenNib } from '@fortawesome/free-solid-svg-icons';

const CreateNewEntryButton = (params: {
  navigateToDailyEntry: () => void;
  className: string;
  btnText: string;
  disabled: boolean;
}) => {
  const { navigateToDailyEntry, className, btnText, disabled } = params;
  const [isLoading, setIsLoading] = useState(false);
  return (
    <button
      disabled={disabled}
      className={`tw-bg-gradient-to-b tw-from-primary-500 tw-to-secondary-500 tw-text-white tw-border-none tw-inline-flex tw-flex-row tw-justify-center tw-items-center tw-gap-2 tw-font-semibold tw-cursor-pointer disabled:tw-cursor-default disabled:tw-bg-none disabled:tw-bg-neutral-200 disabled:tw-text-neutral-600 ${className}`}
      onClick={() => {
        setIsLoading(true);
        navigateToDailyEntry();
      }}
    >
      {isLoading ? (
        <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
      ) : (
        <FontAwesomeIcon icon={faPenNib} />
      )}
      {btnText}
    </button>
  );
};

export default CreateNewEntryButton;
